import { render, staticRenderFns } from "./anglpay.vue?vue&type=template&id=2228e5bb&scoped=true"
import script from "./anglpay.vue?vue&type=script&lang=js"
export * from "./anglpay.vue?vue&type=script&lang=js"
import style0 from "./anglpay.vue?vue&type=style&index=0&id=2228e5bb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2228e5bb",
  null
  
)

export default component.exports